import * as React from "react";
import { forwardRef } from "react";
const MoonSVG = (props, ref) => React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("path", { fillRule: "evenodd", d: "M14.115 2.753a1 1 0 0 1-.303 1.044 6 6 0 0 0 2.304 10.314c.658.208 2.213.7 3.977-.255a1 1 0 0 1 1.428 1.187A10 10 0 1 1 13.286 2.05a1 1 0 0 1 .829.703m-3.12 1.278a8 8 0 1 0 7.686 12.345c-1.497.181-2.685-.202-3.152-.353l-.114-.036a8 8 0 0 1-4.42-11.956", clipRule: "evenodd" }));
const ForwardRef = forwardRef(MoonSVG);
export default ForwardRef;
//# sourceMappingURL=Moon.js.map